import React, { } from 'react';
import './NoFound.scss'
import Footer from '../../components/Footer/Footer';
import { Layout, theme} from 'antd';
import { Header } from 'antd/es/layout/layout';
import MenuBar from '../../components/Menu/MenuBar';
const {  Content } = Layout;

const NoFound =() => {
    const {
        token: { colorBgContainer },
    } = theme.useToken();

    return (
        <div className="animate__animated animate__fadeIn" style={{ height: '100vh' }}>
            <Layout style={{ height: '100vh', overflowX: 'hidden', backgroundColor: 'white' }}>
                <MenuBar />
                <Header className="bg-header-profile" />
                <Layout>
                    <Content style={{
                        padding: 44,
                        minHeight: 280,
                        background: colorBgContainer,
                        overflow: 'auto',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent : 'center'
                    }}
                    >
                    <h1 style={{fontSize : 40}}>404 - No found</h1>
                    </Content>
                </Layout>
            </Layout>
            <Footer />
        </div>
    );
};

export default NoFound;
